import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stock-bin-details',
  templateUrl: './stock-bin-details.component.html',
  styleUrls: ['./stock-bin-details.component.css']
})
export class StockBinDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
